import React, { createContext, useContext, useState, useEffect } from 'react';
import { BRAND_COLOR } from '../data/appData';

const StateContext = createContext();

const initialState = {
  chat: false,
  cart: false,
  userProfile: false,
  notification: false,
};

const allMenus = [
  "Dashboard",
  "Cotizaciones",
  "ordenes",
  "Agenda",
  "instalacion",
  "Stock",
  "Clientes",
  "Finanzas",
  "Seguridad",
  "marketing",
];

// Mapea nombres de módulo del backend a ids de menú del sidebar
const MODULE_TO_MENU = {
  "Dashboard": "dashboard",
  "Cotizaciones": "cotizaciones",
  "Órdenes": "ordenes",
  "Agenda": "agenda",
  "Instalación": "instalacion",
  "Stock": "stock",
  "Clientes": "clientes",
  "Finanzas": "finanzas",
  "Seguridad": "seguridad",
  "Marketing": "marketing",
};

const moduleToMenuId = (m) => MODULE_TO_MENU[m] || m.toLowerCase();

export const ContextProvider = ({ children }) => {
  const [screenSize, setScreenSize] = useState(undefined);
  const [currentColor] = useState(BRAND_COLOR);
  const [activeMenu, setActiveMenu] = useState(true);
  const [isClicked, setIsClicked] = useState(initialState);
  const [cotizacionVisible, setcotizacionVisible] = useState(false);

  const [user, setUser] = useState(null);
  const [menus, setMenus] = useState([]);

  const handleClick = (clicked) => {
    setIsClicked((prevIsClicked) => ({
      ...prevIsClicked,
      [clicked]: !prevIsClicked[clicked],
    }));
  };

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (token) {
      fetch(`${process.env.REACT_APP_BACKEND_URL}/api/users/me/`, {
        headers: { Authorization: `Bearer ${token}` }
      })
        .then(res => res.json())
        .then(data => {
          setUser(data);
          const moduleMenus = (data.modules || []).map(moduleToMenuId);
          setMenus([...moduleMenus, "cerrar_sesion"]);
        })
        .catch(err => {
          console.error("Error cargando usuario", err);
          setMenus([]);
        });
    }
  }, []);

  return (
    <StateContext.Provider value={{
      currentColor, activeMenu, screenSize, setScreenSize,
      handleClick, isClicked, initialState, setIsClicked, setActiveMenu,
      cotizacionVisible, setcotizacionVisible,
      user, menus
    }}>
      {children}
    </StateContext.Provider>
  );
};

export const useStateContext = () => useContext(StateContext);
